import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import { LinearProgress, Tooltip } from "@mui/material";
import { Done, ModelTraining, Sync, Warning } from "@mui/icons-material";
import FaiqActionButton from "./FaiqActionButton";
import { translate } from "helpers/i18n";
import { t } from "i18next";

/**
 * @param {Object} param0 - Component props.
 * @param {obj} param0.value - The object that contains row original value
 * @param {function} param0.t - The translation function used to get the localized label for the status.
 * @returns {JSX.Element} The rendered `Chip` component.
 */
const FaiqIntegration = ({ value: original }) => {
	const faiq = original?.faiq || {};

	const getContent = () => {
		if (!lod_.isObject(faiq) || lod_.isEmpty(faiq) || faiq?.state === "waiting") {
			/* When asset has no source linked */
			return (
				<FaiqActionButton
					color="info"
					text={t("ASSETS.FAIQ.STATUS.waiting")}
					icon={<ModelTraining fontSize="small" />}
				/>
			);
		} else if (faiq.state === "importing") {
			/* Importing */
			return (
				<MDBox
					style={{
						backgroundColor: "red",
						overflow: "hidden",
						borderRadius: "100px",
						width: "100%",
						height: "100%"
					}}
				>
					<LinearProgress color="info" />
				</MDBox>
			);
		} else if (faiq.state === "error") {
			/* Error */
			return (
				<Tooltip title={translate(faiq.error)} placement="left">
					<MDBox
						sx={{
							width: "100%",
							display: "flex"
						}}
					>
						<FaiqActionButton
							color="error"
							text={t("ASSETS.FAIQ.STATUS.error")}
							icon={<Sync fontSize="small" />}
						/>
					</MDBox>
				</Tooltip>
			);
		} else if (faiq.state === "outdated") {
			/* Outdated */
			return (
				<FaiqActionButton
					color="warning"
					text={t("ASSETS.FAIQ.STATUS.toUpdate")}
					icon={<Sync fontSize="small" />}
				/>
			);
		} else if (faiq.state === "done") {
			/* Asset is up with FAIQ */
			return (
				<FaiqActionButton
					color="success"
					text={t("ASSETS.FAIQ.STATUS.done")}
					icon={<Done fontSize="small" />}
				/>
			);
		} else if (faiq.trainedKnowledges === false) {
			/* Knowledged not all trained */
			return (
				<FaiqActionButton
					color="success"
					text={t("ASSETS.FAIQ.STATUS.done")}
					icon={
						<Tooltip title={t("FAIQ.ACTIONS.errorDetected")} placement="top" arrow>
							<Warning fontSize="small" color="warning" />
						</Tooltip>
					}
				/>
			);
		} else {
			return null;
		}
	};

	return getContent();
};

export default FaiqIntegration;
